const GiftIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_239_1070)">
        <path
          d="M17.8572 4.28564H2.14293C1.35395 4.28564 0.714355 4.92524 0.714355 5.71422V8.57136C0.714355 9.36033 1.35395 9.99993 2.14293 9.99993H17.8572C18.6462 9.99993 19.2858 9.36033 19.2858 8.57136V5.71422C19.2858 4.92524 18.6462 4.28564 17.8572 4.28564Z"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8571 10V17.8571C17.8571 18.236 17.7065 18.5994 17.4387 18.8673C17.1708 19.1351 16.8074 19.2857 16.4285 19.2857H3.57139C3.19251 19.2857 2.82915 19.1351 2.56124 18.8673C2.29334 18.5994 2.14282 18.236 2.14282 17.8571V10"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 4.28564V19.2856"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2858 0.714355L10.0001 4.28578L5.71436 0.714355"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_239_1070">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default GiftIcon;
